import { render, staticRenderFns } from "./NsFooter.vue?vue&type=template&id=57735948&scoped=true&"
import script from "./NsFooter.vue?vue&type=script&lang=js&"
export * from "./NsFooter.vue?vue&type=script&lang=js&"
import style0 from "./NsFooter.vue?vue&type=style&index=0&id=57735948&prod&scoped=true&lang=scss&"
import style1 from "./NsFooter.vue?vue&type=style&index=1&id=57735948&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57735948",
  null
  
)

export default component.exports